import { Switch as NSwitch, type SwitchProps as NSwitchProps } from '@natera/material/lib/switch'
import { useId } from 'react'

export function Switch({ ...rest }: NSwitchProps) {
  const id = useId()

  return (
    <NSwitch
      id={id}
      variant="v3"
      size="small"
      {...rest}
    />
  )
}
